import React from 'react';

import constants from '@/utils/utils/constants';

import styles from './Burger.styles';

const Burger = ({ isMenuOpen, toggleMenu }) => (
  <div css={styles} onClick={toggleMenu} className="mobile-menu">
    <div className={`btn ${isMenuOpen && 'active'}`}>
      <span />
    </div>
    <span>{constants.menu}</span>
  </div>
);

export default Burger;
